import dynamic from 'next/dynamic';
import React from 'react';

import { CountryDirectionType } from '../../../../entities/providers/hooks/hooks.type';

export const fields = {
  sendMethod: dynamic(() => import('./send-method')),
  email: dynamic(() => import('./email')),
  phone: dynamic(() => import('./phone')),
  fixedPhone: dynamic(() => import('./fixed-phone')),
  firstName: dynamic(() => import('./first-name')),
  lastName: dynamic(() => import('./last-name')),
  street: dynamic(() => import('./street')),
  houseName: dynamic(() => import('./house-name')),
  buildingNumber: dynamic(() => import('./building-number')),
  apartments: dynamic(() => import('./apartments')),
  city: dynamic(() => import('./city')),
  cityText: dynamic(() => import('./city-text')),
  cityDropdown: dynamic(() => import('./city-dropdown')),
  postCode: dynamic(() => import('./post-code')),
  postCodeAutoComplete: dynamic(() => import('./post-code-autocomplete')),
  region: dynamic(() => import('./region')),
  dispatchDate: dynamic(() => import('./dispatch-date')),
  dropOffPoint: dynamic(() => import('./drop-off-point')),
  department: dynamic(() => import('./departments-autocomplete')),
};

export type FieldKey = keyof typeof fields;
export type ReturnComponent = React.ComponentType<{ type: CountryDirectionType }>;

const formLabels: Record<FieldKey | string, string> = {
  dispatchDate: 'rates:rates.form.dispatchDate',
};

export const getLabel = (key: FieldKey): string => formLabels[key] || '';

export const pickFields = (
  ...keys: FieldKey[]
): {
  Component: ReturnComponent;
  type: FieldKey;
}[] =>
  keys.map((key) => ({
    Component: fields[key] as any, // eslint-disable-line @typescript-eslint/no-explicit-any
    type: key,
  }));
